import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import EvidenceUpload from '@/modules/EvidenceUpload/EvidenceInfo.vue';

var UploadEvidents = /*#__PURE__*/function (_Vue) {
  _inherits(UploadEvidents, _Vue);

  var _super = _createSuper(UploadEvidents);

  function UploadEvidents() {
    _classCallCheck(this, UploadEvidents);

    return _super.apply(this, arguments);
  }

  return UploadEvidents;
}(Vue);

__decorate([Prop({
  default: ''
})], UploadEvidents.prototype, "caseId", void 0);

UploadEvidents = __decorate([Component({
  components: {
    EvidenceUpload: EvidenceUpload
  }
})], UploadEvidents);
export default UploadEvidents;